var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1376_814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.93453 6.31726H0.992497C0.817543 6.31726 0.675781 6.45909 0.675781 6.63398V19.298C0.675781 19.473 0.817543 19.6148 0.992497 19.6148H4.93453C5.10948 19.6148 5.25124 19.473 5.25124 19.298V6.63398C5.25124 6.45909 5.10948 6.31726 4.93453 6.31726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96453 0.0216064C1.53019 0.0216064 0.363281 1.18725 0.363281 2.62C0.363281 4.0534 1.53019 5.21948 2.96453 5.21948C4.39773 5.21948 5.56369 4.05333 5.56369 2.62C5.56375 1.18725 4.39773 0.0216064 2.96453 0.0216064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.961 6.00244C13.3778 6.00244 12.2074 6.68306 11.4975 7.45642V6.63391C11.4975 6.45902 11.3557 6.31719 11.1808 6.31719H7.40558C7.23063 6.31719 7.08887 6.45902 7.08887 6.63391V19.298C7.08887 19.4729 7.23063 19.6147 7.40558 19.6147H11.339C11.514 19.6147 11.6557 19.4729 11.6557 19.298V13.0322C11.6557 10.9208 12.2292 10.0982 13.7011 10.0982C15.304 10.0982 15.4314 11.4169 15.4314 13.1408V19.298C15.4314 19.473 15.5732 19.6147 15.7481 19.6147H19.683C19.858 19.6147 19.9997 19.473 19.9997 19.298V12.3516C19.9997 9.21197 19.4011 6.00244 14.961 6.00244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1376_814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6364,
    height: 19.6364,
    fill: "white",
    transform: "translate(0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f4ada23b75c6ce5733fa1e00a070f6e3.svg";
export { ForwardRef as ReactComponent };